import { render, staticRenderFns } from "./NonconformingProductManage.vue?vue&type=template&id=4ef137f3&scoped=true"
import script from "./NonconformingProductManage.vue?vue&type=script&lang=js"
export * from "./NonconformingProductManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef137f3",
  null
  
)

export default component.exports